// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"Accordion_accordionContainer__Hc9U5","headerContent":"Accordion_headerContent__AhVu3","content":"Accordion_content__KuJ7A"};